import { useMemo, useState } from "react";
import { Page, DataTable } from "@iq/models";
import useCustomerStore from "../states/customers";
import CustomerDetails from "../modals/customerDetails/customerDetails";
import "../styles/customers.css";
import useIsSmallScreen from "../hooks/useIsSmallScreen";

function Customers({ onOpenCustomerDetails = () => {} }) {
    const storedCustomers = useCustomerStore((state) => state.customers);
    const setCustomers = useCustomerStore((state) => state.setCustomers);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const customers = useMemo(() => {
        if (Array.isArray(storedCustomers)) {
            return storedCustomers;
        }

        return Array.isArray(storedCustomers?.customers) ? storedCustomers.customers : [];
    }, [storedCustomers]);

    const tableConfig = useMemo(() => ({
        columns: [
            {
                key: "id",
                label: "ID",
                accessor: "id",
                width: "0.5fr",
                filterable: true,
            },
            {
                key: "name",
                label: "Name",
                accessor: "name",
                width: "1fr",
                filterable: true,
            },
            {
                key: "email",
                label: "Email",
                accessor: "email",
                width: "1fr",
                filterable: true,
            },
            {
                key: "phone",
                label: "Phone",
                accessor: "phone",
                width: "1fr",
                filterable: true,
            },
        ],
        onRowClick: (customer) => {
            setSelectedCustomer(customer);
            onOpenCustomerDetails(customer);
        },
    }), [onOpenCustomerDetails]);
    
    const mobileTableConfig = useMemo(() => ({
        columns: [
            {
                key: "id",
                label: "ID",
                accessor: "id",
                width: "1fr",
            },
            {
                key: "name",
                label: "Name",
                accessor: "name",
                width: "3fr",
                filterable: true,
            },
            {
                key: "email",
                label: "Email",
                accessor: "email",
                width: "3fr",
                filterable: true,
            },
            {
                key: "phone",
                label: "Phone",
                accessor: "phone",
                width: "3fr",
                filterable: true,
            },
        ],
        onRowClick: (customer) => {
            setSelectedCustomer(customer);
            onOpenCustomerDetails(customer);
        },
    }), [onOpenCustomerDetails]);
    
    const isSmallScreen = useIsSmallScreen();

    return (
        <Page title="Customers">
            <DataTable
                rowData={customers}
                rowKey = {(customer) => customer.id}
                tableConfig={isSmallScreen ? mobileTableConfig : tableConfig}
                onRowClick={(customer) => {
                    setSelectedCustomer(customer);
                    onOpenCustomerDetails(customer);
                }}
            />
            <CustomerDetails
                isOpen={!!selectedCustomer}
                customer={selectedCustomer}
                onClose={() => setSelectedCustomer(null)}
            />
        </Page>
    );
}

export default Customers;